import { BroadcastVariables } from "~/entities/broadcast";
import { Contact } from "~/entities/contacts";


/**
 * Заменяет значения переменных контакта в переменных шаблона данными контакта
 * **/
export function transformBroadcastVariables(variables: BroadcastVariables, customer: Contact): BroadcastVariables {
	const regex = /^{{|}}$/g;
	const processBuffer: {
		pattern: string;
		fieldId: string;
		replaceValue?: unknown;
	}[] = [];
	const allVariables = [
		...variables.bodyVars,
		...variables.buttonVars,
		...variables.footerVars,
		...variables.headerVars,
	];

	for (const variable of allVariables) {
		if (variable.match(regex)) {
			if (!processBuffer.find((item) => item.pattern === variable)) {
				processBuffer.push({
					pattern: variable,
					fieldId: variable.replace(regex, ''),
				});
			}
		}
	}

	const fieldIds = processBuffer.map((item) => item.fieldId);

	const fields: Record<string, unknown>[] = fieldIds.map(fieldId => {
		const sysField = customer.sysFieldValues.find(field => field.sysField.id === fieldId);
		const customField = customer.customFieldValues.find(field => field.customField.id === fieldId);
		if (!sysField && !customField) {
			return null;
		}
		return {
			[fieldId]: sysField?.value || customField?.value
		}
	}).filter(x => x !== null)

	for (const item of processBuffer) {
		const fieldValue = fields.find(x => x[item.fieldId] !== undefined);
		if (fieldValue !== undefined) {
			item.replaceValue = fieldValue[item.fieldId];
		}
	}

	const bodyVars = variables.bodyVars.map(
		replaceValuesByPattern(processBuffer),
	);

	const buttonVars = variables.buttonVars.map(
		replaceValuesByPattern(processBuffer),
	);

	const footerVars = variables.footerVars.map(
		replaceValuesByPattern(processBuffer),
	);

	const headerVars = variables.headerVars.map(
		replaceValuesByPattern(processBuffer),
	);

	return {
		bodyVars,
		buttonVars,
		footerVars,
		headerVars
	};

	function replaceValuesByPattern(
		processBuffer: {
			pattern: string;
			fieldId: string;
			replaceValue?: unknown;
		}[],
	) {
		return (fieldValue: string) => {
			const replaceData = processBuffer.find((item) => item.pattern === fieldValue);
			if (replaceData) {
				return String(replaceData.replaceValue);
			}
			return fieldValue;
		};
	}
}

/**
 * Заменяет значения переменных данными из fieldMap
 * **/
export function processVariables(
	variables: Record<string, string>,
	fieldMap: Record<string, string>
): Record<string, string> {
	const variablesCopy: Record<string, string> = JSON.parse(JSON.stringify(variables));
	const regex = /{{([^{}]*)}}/g;
	for (const [key, value] of Object.entries(variablesCopy)) {
		let newValue = value;
		const results: RegExpExecArray[] = [];
		let m: RegExpExecArray | null;
		while ((m = regex.exec(value))) {
			results.push(m);
		}
		if (results && results.length) {
			for (const r of results) {
				const slotClass = fieldMap[r[1]] ? 'field-variable' : 'variable-slot';
				const resplaceText = `<span class="${slotClass}">${fieldMap[r[1]] || ''} </span>`;
				newValue = newValue.replace(r[0], resplaceText);
			}
		}
		variablesCopy[key] = newValue;
	}

	return variablesCopy;
}

/**
 * Заменяет значения переменных шаблона, html вставкой для превью
 * **/
export function createTemplateHtml(
	text: string,
	variables: Record<string, string>,
	fieldMap: Record<string, string>
): string {
	const regex = /{{([^{}]*)}}/g;

	const processedVariables = processVariables(variables, fieldMap);

	const results: RegExpExecArray[] = [];
	let m: RegExpExecArray | null;
	while ((m = regex.exec(text))) {
		results.push(m);
	}
	if (results && results.length) {
		for (const r of results) {
			const replaceText = `<span class="variable-slot">${processedVariables[r[1]] || r[0]} </span>`;
			text = text.replace(r[0], replaceText)
		}
	}

	return text.replace(/[\r\n]/g, '<br />');
}

/**
 * Заменяет значения переменных шаблона текстом переменной (без подстановки данных контакта)
 * @returns Строка результата
 * **/
export function replaceTemplateVariables(text: string | null, variables: Record<string, string>): string | null {
	if (text == null) {
		return null;
	}

	if (!text.length) {
		return '';
	}

	const regex = /{{([^{}]*)}}/g;

	const results: RegExpExecArray[] = [];
	let m: RegExpExecArray | null;
	while ((m = regex.exec(text))) {
		results.push(m);
	}
	if (results && results.length) {
		for (const r of results) {
			text = text.replace(r[0], variables[r[1]] || r[0])
		}
	}

	return text;
}